import { findKey, isEqual, omitBy, pickBy } from 'lodash';
import { KeyBindingUtil, RichUtils, getDefaultKeyBinding } from 'draft-js';

import {
  BUTTON_TITLE,
  BUTTON_SUBTITLE,
  BUTTON_NUMBERING,
  BUTTON_BULLETS,
  BUTTON_BLOCKQUOTE,
  BUTTON_CODE_BLOCK,
  BUTTON_LINK,
  BUTTON_ALIGN_LEFT,
  BUTTON_ALIGN_RIGHT,
  BUTTON_ALIGN_CENTER,
  BUTTON_ALIGN_JUSTIFY,
} from '../constants/buttons';
import { BUTTON_SHORTCUTS } from '../constants/button-shortcuts';
import { toggleBlockType, toggleBlockTypeAndEnsureSpaces } from '../modifiers/block-type-modifiers';
import { toggleLink } from '../modifiers/link-modifiers';
import { setTextAlignment } from '../modifiers/text-alignment-modifiers';

const bindToggleBlockType = ({ command, editorState }) => toggleBlockType(command, editorState);
const bindSetTextAlignment = ({ command, editorState }) => setTextAlignment(command, editorState);

const BUTTON_HANDLERS = {
  [BUTTON_TITLE]: bindToggleBlockType,
  [BUTTON_SUBTITLE]: bindToggleBlockType,
  [BUTTON_NUMBERING]: bindToggleBlockType,
  [BUTTON_BULLETS]: bindToggleBlockType,
  [BUTTON_BLOCKQUOTE]: bindToggleBlockType,
  [BUTTON_CODE_BLOCK]: ({ command, editorState }) => toggleBlockTypeAndEnsureSpaces(command, editorState),
  [BUTTON_LINK]: toggleLink,
  [BUTTON_ALIGN_LEFT]: bindSetTextAlignment,
  [BUTTON_ALIGN_RIGHT]: bindSetTextAlignment,
  [BUTTON_ALIGN_CENTER]: bindSetTextAlignment,
  [BUTTON_ALIGN_JUSTIFY]: bindSetTextAlignment,
};

// Update the shortcuts list on key bindings update!
export const keyBindingsLabel = ({ isCodeBlockEnabled, isMac, t }) =>
  // prettier-ignore
  isCodeBlockEnabled ?
    isMac ?
      t('text-editor.enter-content-editor-mac') :
      t('text-editor.enter-content-editor') :
    isMac ?
      t('text-editor.enter-content-editor-without-codeblock-mac') :
      t('text-editor.enter-content-editor-without-codeblock');

export const getKeyMatch = (bindings, e) => {
  const shortcut = pickBy({
    command: KeyBindingUtil.hasCommandModifier(e),
    commandOption: Boolean((e.ctrlKey || e.metaKey) && e.altKey),
    option: Boolean(e.altKey),
    shift: Boolean(e.shiftKey),
    key: String.fromCharCode(e.keyCode),
  });

  return findKey(bindings, binding => isEqual(binding, shortcut));
};

export const getButtonShortcuts = isCodeBlockEnabled =>
  omitBy(BUTTON_SHORTCUTS, (_, button) => button === BUTTON_CODE_BLOCK && !isCodeBlockEnabled);

export const keyBindingFn = isCodeBlockEnabled => e => {
  const keyMatch = getKeyMatch(getButtonShortcuts(isCodeBlockEnabled), e);
  if (keyMatch) {
    return keyMatch;
  }

  return getDefaultKeyBinding(e);
};

const getNewState = ({ command, identifier, editorState, openModal }) => {
  const handler = BUTTON_HANDLERS[command];

  if (handler) {
    return handler({ command, editorState, identifier, openModal });
  }

  return RichUtils.handleKeyCommand(editorState, command);
};

export const handleKeyCommand = ({ command, identifier, editorState, openModal, handleEditorChange }) => {
  const newState = getNewState({ command, identifier, editorState, openModal });

  if (newState) {
    handleEditorChange(newState);
    return 'handled';
  }

  return 'not-handled';
};



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/key-bindings.js